<div class="marv_progress_bar"
    [class.small]="this.sizeProgressBar === 'small'"
    [class.very_small]="this.sizeProgressBar === 'very-small'"
    [class.small_value]="this.pourcent < 50"
    [class.secondary]="this.colorProgressBar === 'secondary'"
    [class.blue]="this.colorProgressBar === 'blue'"
    [class.red]="this.colorProgressBar === 'red'"
    [class.green]="this.colorProgressBar === 'green'"
    [class.orange]="this.colorProgressBar === 'orange'"
    [class.purple]="this.colorProgressBar === 'purple'"
    [class.marvesting]="this.colorProgressBar === 'marvesting'"
    >
    <div class="marv_progress_bar_content">
        <div class="marv_progress_bar_content_value" [style]="{'width': this.pourcent+'%'}">
            <div class="marv_progress_bar_value">
                @if(this.showValue){
                    <div class="marv_progress_bar_value_label">{{(this.showPourcent ? this.pourcent+'%' : this.valueProgressBar)}}</div>
                }
            </div>
            @if(this.showSepValue){
                <div class="marv_progress_bar_value_sep"></div>   
            }
        </div>
    </div>
   
    @if(this.showMax){
        <div class="marv_progress_bar_max">{{(this.showPourcent ? '100%' : this.maxProgressBar)}}</div>
    }
</div>